import { TrackInteractionDirective } from '@analytics/events';
import { Component, input } from '@angular/core';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';

import { FeedbackComponent } from '../feedback/feedback.component';
import { Accordion } from '../models/accordion.model';
import { FeedBackSettings } from '../models/feedback.model';

@Component({
  selector: 'wl-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: [
    './accordion.component.essent.scss',
    './accordion.component.ed.scss',
  ],
  standalone: true,
  imports: [
    TrackInteractionDirective,
    FeedbackComponent,
    RichTextWrapperComponent,
  ],
})
export class AccordionComponent {
  readonly accordion = input.required<Accordion>();
  readonly feedbackSettings = input<FeedBackSettings>();
}
